import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BASE}/api`,
  withCredentials: true,
});

// Attach token from localStorage if present (fallback when cookies disabled in preview)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const formatErr = (e) => {
  const detail = e?.response?.data?.detail;
  if (!detail) return e?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x)))
      .join(" ");
  return String(detail);
};

export const fmtPrice = (n, ccy = "EUR") => {
  if (n == null) return "";
  try {
    return new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: ccy,
      maximumFractionDigits: 0,
    }).format(n);
  } catch {
    return `${ccy} ${n}`;
  }
};

export const cx = (...parts) => parts.filter(Boolean).join(" ");
